import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/premium-certificate/appEnv';

export default appStarterFactory(appEnv);
